// src/telemetry/hooks/useTrackPage.ts

import { useEffect } from 'react';

import { telemetryManager }
  from '../TelemetryManager';

interface UseTrackPageProps {

  moduleName: string;

  submoduleName: string;

  routePath: string;

}

const PREV_ROUTE_STORAGE_KEY = '__telemetry_previous_route__';

export function useTrackPage({
  moduleName,
  submoduleName,
  routePath,
}: UseTrackPageProps) {

  useEffect(() => {
    const currentRoute = routePath;
    const previousRoute = sessionStorage.getItem(PREV_ROUTE_STORAGE_KEY);

    telemetryManager.setFocus({
      moduleName,
      submoduleName,
      routePath: currentRoute,
    });

    telemetryManager.track({

      moduleName,

      submoduleName,

      routePath,

      eventType:
        'page_view',

      actionType:
        'page_view',

      actionLabel:
        `${moduleName} - ${submoduleName}`,

      previousRoute,

      metadata: {
        previousRoute,
        currentRoute,
        navigationType:
          previousRoute === null ? 'initial' : 'route_change',
      },

    });

    sessionStorage.setItem(PREV_ROUTE_STORAGE_KEY, currentRoute);

  }, [
    moduleName,
    submoduleName,
    routePath,
  ]);

}
